import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { Link, useNavigate } from 'react-router-dom'
import { SectionDetailType } from '../../@types/home'
import { getSectionsDetail } from '../../api/home'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { setPrevScroll, setRecentlySearchWord } from '../../js/script'
import { imgURL } from '../../pages/Home'
import { useAppContext } from '../provider/AppProvider'

export default function PopularSearchKeyword({
  el,
  index,
  popularKeyword,
}: {
  el: any
  index: number
  popularKeyword: string[]
}) {
  const [sectionItem, setSectionItem] = useState<SectionDetailType>()
  const [keyword, setKeyword] = useState<string>('')
  const { isAppView } = useAppContext()
  const onChangeData = (e: React.FormEvent<HTMLInputElement>) => {
    setKeyword(e.currentTarget.value)
  }
  const navigate = useNavigate()

  useEffect(() => {
    getSectionsDetail(el.sectionNo)
      .then((res) => {
        res.data.map((el: any) => {
          setSectionItem(el)
        })
      })
      .catch((err) => console.log(err))
  }, [])

  function isFirstCharSpace(input: any) {
    return input.charAt(0) === ' '
  }

  return (
    <div
      className='keyword_search'
      style={{ minHeight: isMobile ? '180px' : '224px' }}
      onClick={(): void => {
        const gtmNavigateClick: DataLayerArgs = {
          dataLayer: {
            event: 'select_content',
            event_info: {
              content_type: '홈모듈',
              content_id: String(el.sectionNo),
              content_name: el.sectionName,
            },
          },
        }
        if (isAppView) {
          sendSetAppsflyerEvent({
            eventName: 'select_content',
            eventType: {
              content_type: '홈모듈',
              content_id: String(el.sectionNo),
              content_name: el.sectionName,
            },
          })
        } else {
          TagManager.dataLayer(gtmNavigateClick)
        }
      }}
    >
      <div className='home_module_title'>
        <p>{sectionItem?.promotionText}</p>
        <p>
          <strong>{sectionItem?.sectionExplain}</strong>
        </p>
      </div>
      <div className='search_input'>
        <div className='search_title'>찾으시는 상품을 검색해보세요</div>
        <div className='search_box'>
          <input
            type='text'
            placeholder='검색어를 입력해 보세요.'
            onChange={onChangeData}
            value={keyword}
            // 키보드에서 엔터키를 누르면 검색이 되도록
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                if (keyword && !isFirstCharSpace(keyword)) {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/search/searchResult?keyword=${keyword}`,
                    })
                  } else {
                    navigate(`/search/searchResult?keyword=${keyword}`)
                  }
                  setRecentlySearchWord(keyword)
                } else {
                  alert('첫자리 공백은 검색이 불가합니다.')
                }
              }
            }}
          />
          {keyword && (
            <button className='search_keyword_delete'>
              <img
                src={`${imgURL}/icon_clear_button_gray.png`}
                alt='검색어 초기화'
                onClick={(): void => {
                  setKeyword('')
                }}
              />
            </button>
          )}
          <button>
            <img
              src={`${imgURL}/icon_search.png`}
              alt='검색'
              onClick={(): void => {
                if (keyword && !isFirstCharSpace(keyword)) {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/search/searchResult?keyword=${keyword}`,
                    })
                  } else {
                    navigate(`/search/searchResult?keyword=${keyword}`)
                  }
                  setRecentlySearchWord(keyword)
                } else {
                  alert('첫자리 공백은 검색이 불가합니다.')
                }
              }}
            />
          </button>
        </div>
      </div>
      <div className='search_keyword'>
        {!isMobile && <p>{sectionItem?.promotionText}</p>}
        <ul>
          {popularKeyword?.map((el: string): JSX.Element => {
            return (
              <li key={el}>
                <div
                  // to={`/search/searchResult?keyword=${el}`}
                  onClick={(): void => {
                    if (isAppView) {
                      RNPostMessage(AFWebLinkType.moveToLink, {
                        url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/search/searchResult?keyword=${el}`,
                      })
                    } else {
                      navigate(`/search/searchResult?keyword=${el}`)
                    }
                    setPrevScroll(document.documentElement.scrollTop)
                  }}
                >
                  {el} →
                </div>
              </li>
            )
          })}
        </ul>
      </div>
      {/* {idx + 1 === homeModule.length || idx === 0 ? null : <hr />} */}
      {index !== 0 && <hr />}
    </div>
  )
}
